import { Controller } from 'react-hook-form';

import { CalendarIcon } from '@/assets/icons';
import { DateRangePicker } from '@/components/common';
import { ERROR_REQUIRED_FIELD } from '@/constants/validationError.constants';

import { IGuestProfileUpdateSection } from '@/features/face-id-profiles';

const GuestProfileSection = ({
  defaultValues,
  errors,
  control,
  formFields,
  setValue,
  trigger,
}: IGuestProfileUpdateSection) => {
  return (
    <Controller
      name={formFields.guestValidFrom}
      control={control}
      rules={{
        validate: (_, formValues) =>
          formValues.guestValidFrom && formValues.guestValidTo ? true : ERROR_REQUIRED_FIELD,
      }}
      render={() => (
        <DateRangePicker
          align="start"
          label="Guest Valid Period"
          prefixIcon={<CalendarIcon />}
          required
          initialDateFrom={defaultValues?.guestValidFrom}
          initialDateTo={defaultValues?.guestValidTo}
          calendarDisabled={{ before: new Date() }}
          onUpdate={({ range }) => {
            setValue(formFields.guestValidFrom, range.from, { shouldDirty: true });
            setValue(formFields.guestValidTo, range.to, { shouldDirty: true });
            trigger(formFields.guestValidFrom);
          }}
          error={errors[formFields.guestValidFrom]?.message}
        />
      )}
    />
  );
};

export default GuestProfileSection;
